<script setup lang="ts">
import FooterBar from '@/components/footer-bar/FooterBar.vue'
import { ref } from 'vue'
import PetItem from './components/PetItem.vue'
import PetFusion from './components/PetFusion.vue'
import PetExcite from './components/PetExcite.vue'
import PetEvolution from './components/PetEvolution.vue'

const curTab = ref('info')
</script>

<template>
  <div class="monster-ranch page">
    <h2>魔物牧场</h2>
    <el-tabs v-model="curTab" stretch>
      <el-tab-pane label="魔物" name="info" class="pane" lazy>
        <PetItem class="pane-item" />
      </el-tab-pane>
      <el-tab-pane label="融合" name="fusion" class="pane" lazy>
        <PetFusion class="pane-item" />
      </el-tab-pane>
      <el-tab-pane label="激发" name="excite" class="pane" lazy>
        <PetExcite class="pane-item" />
      </el-tab-pane>
      <el-tab-pane label="进化" name="evolution" class="pane" lazy>
        <PetEvolution class="pane-item" />
      </el-tab-pane>
    </el-tabs>

    <FooterBar />
  </div>
</template>

<style lang="scss" scoped>
.monster-ranch {
  padding-top: 0;
  display: flex;
  flex-flow: column;
  height: 100%;
  h2 {
    margin-bottom: 0;
  }
  .el-tabs {
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-flow: column nowrap;
    :deep() {
      .el-tabs__content {
        flex: 1;
        .pane {
          height: 100%;
          .pane-item {
            height: 100%;
            overflow: hidden;
            display: flex;
            flex-flow: column nowrap;
          }
        }
      }
    }
  }
}
</style>
